module.exports = __webpack_public_path__ + "img/AgeIcon.2f0e9bb2.png";